export default {
  WELCOME_TOUR: 'WELCOME_TOUR',
  MULTILINGUAL_TOUR: 'MULTILINGUAL_TOUR',
};
